import { render, staticRenderFns } from "./lesson-list.vue?vue&type=template&id=b63cda84&scoped=true"
import script from "./lesson-list.vue?vue&type=script&lang=js"
export * from "./lesson-list.vue?vue&type=script&lang=js"
import style0 from "./lesson-list.vue?vue&type=style&index=0&id=b63cda84&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63cda84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b63cda84')) {
      api.createRecord('b63cda84', component.options)
    } else {
      api.reload('b63cda84', component.options)
    }
    module.hot.accept("./lesson-list.vue?vue&type=template&id=b63cda84&scoped=true", function () {
      api.rerender('b63cda84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/detail-pane/components/lesson-list.vue"
export default component.exports